import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { u as uuidv4, j as transformToVersionedTag } from './utils.js';
import { u as updateTreeById, m as markChildrenAs, r as recalculateIndeterminateTreeState, f as findSelectedItems, c as convertToOriginalItems, i as isHaveFoundChildren, a as updateTreeByIds, d as defineCustomElement$3 } from './wpp-tree-item2.js';
import { d as defineCustomElement$n } from './wpp-action-button2.js';
import { d as defineCustomElement$m } from './wpp-checkbox2.js';
import { d as defineCustomElement$l } from './wpp-icon-chevron2.js';
import { d as defineCustomElement$k } from './wpp-icon-cross2.js';
import { d as defineCustomElement$j } from './wpp-icon-dash2.js';
import { d as defineCustomElement$i } from './wpp-icon-error2.js';
import { d as defineCustomElement$h } from './wpp-icon-info2.js';
import { d as defineCustomElement$g } from './wpp-icon-more2.js';
import { d as defineCustomElement$f } from './wpp-icon-success2.js';
import { d as defineCustomElement$e } from './wpp-icon-tick2.js';
import { d as defineCustomElement$d } from './wpp-icon-triangle-fill2.js';
import { d as defineCustomElement$c } from './wpp-icon-warning2.js';
import { d as defineCustomElement$b } from './wpp-inline-message2.js';
import { d as defineCustomElement$a } from './wpp-internal-label2.js';
import { d as defineCustomElement$9 } from './wpp-internal-tooltip2.js';
import { d as defineCustomElement$8 } from './wpp-label2.js';
import { d as defineCustomElement$7 } from './wpp-list-item2.js';
import { d as defineCustomElement$6 } from './wpp-menu-context2.js';
import { d as defineCustomElement$5 } from './wpp-spinner2.js';
import { d as defineCustomElement$4 } from './wpp-tooltip2.js';
import { d as defineCustomElement$2 } from './wpp-typography2.js';

const wppTreeCss = ".typography-5xl-display{font-size:var(--wpp-typography-5xl-display-font-size, 48px);font-family:var(--wpp-typography-5xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-5xl-display-line-height, 62px);letter-spacing:var(--wpp-typography-5xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-5xl-display-text-transform, initial);color:var(--wpp-typography-5xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-5xl-display-font-weight, 600);font-style:var(--wpp-typography-5xl-display-font-style, normal)}.typography-4xl-display{font-size:var(--wpp-typography-4xl-display-font-size, 36px);font-family:var(--wpp-typography-4xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-4xl-display-line-height, 48px);letter-spacing:var(--wpp-typography-4xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-4xl-display-text-transform, initial);color:var(--wpp-typography-4xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-4xl-display-font-weight, 600);font-style:var(--wpp-typography-4xl-display-font-style, normal)}.typography-3xl-heading{font-size:var(--wpp-typography-3xl-heading-font-size, 28px);font-family:var(--wpp-typography-3xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-3xl-heading-line-height, 40px);letter-spacing:var(--wpp-typography-3xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-3xl-heading-text-transform, initial);color:var(--wpp-typography-3xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-3xl-heading-font-weight, 600);font-style:var(--wpp-typography-3xl-heading-font-style, normal)}.typography-2xl-heading{font-size:var(--wpp-typography-2xl-heading-font-size, 24px);font-family:var(--wpp-typography-2xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-2xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-2xl-heading-text-transform, initial);color:var(--wpp-typography-2xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xl-heading-font-weight, 600);font-style:var(--wpp-typography-2xl-heading-font-style, normal)}.typography-xl-heading{font-size:var(--wpp-typography-xl-heading-font-size, 20px);font-family:var(--wpp-typography-xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-xl-heading-text-transform, initial);color:var(--wpp-typography-xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xl-heading-font-weight, 600);font-style:var(--wpp-typography-xl-heading-font-style, normal)}.typography-l-strong{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-strong-font-weight, 600);font-style:var(--wpp-typography-l-strong-font-style, normal)}.typography-l-midi{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-midi-font-weight, 500);font-style:var(--wpp-typography-l-midi-font-style, normal)}.typography-l-body{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-body-font-weight, 400);font-style:var(--wpp-typography-l-body-font-style, normal)}.typography-m-strong{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-strong-font-weight, 600);font-style:var(--wpp-typography-m-strong-font-style, normal)}.typography-m-midi{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-midi-font-weight, 500);font-style:var(--wpp-typography-m-midi-font-style, normal)}.typography-m-body{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-body-font-weight, 400);font-style:var(--wpp-typography-m-body-font-style, normal)}.typography-s-strong{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal)}.typography-s-midi{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-midi-font-weight, 500);font-style:var(--wpp-typography-s-midi-font-style, normal)}.typography-s-body{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal)}.typography-xs-strong{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-strong-font-weight, 600);font-style:var(--wpp-typography-xs-strong-font-style, normal)}.typography-xs-midi{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-midi-font-weight, 500);font-style:var(--wpp-typography-xs-midi-font-style, normal)}.typography-xs-body{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-body-font-weight, 400);font-style:var(--wpp-typography-xs-body-font-style, normal)}.typography-2xs-strong{font-size:var(--wpp-typography-2xs-strong-font-size, 10px);font-family:var(--wpp-typography-2xs-strong-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xs-strong-line-height, 20px);letter-spacing:var(--wpp-typography-2xs-strong-letter-spacing, 0.5px);text-transform:var(--wpp-typography-2xs-strong-text-transform, uppercase);color:var(--wpp-typography-2xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xs-strong-font-weight, 700);font-style:var(--wpp-typography-2xs-strong-font-style, normal)}:host{--tree-item-padding:var(--wpp-tree-item-padding, 6px 4px 0 4px);--tree-container-width:var(--wpp-tree-container-width, 100%);--tree-container-height:var(--wpp-tree-container-height, 100%);--tree-container-bg-color:var(--wpp-tree-container-bg-color, var(--wpp-grey-color-000));--tree-input-trigger-area:var(--wpp-tree-trigger-area, 32px);--tree-item-icon-end-color:var(--wpp-tree-icon-end-color, var(--wpp-grey-color-800));display:-ms-flexbox;display:flex;padding:var(--tree-item-padding)}.container{display:grid;width:100%;overflow:hidden}.content-container{display:grid;overflow:hidden;-webkit-transition:height 500ms ease;transition:height 500ms ease}.empty-tree-text{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);margin:0;text-align:center}";

const WppTree$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.wppChange = createEvent(this, "wppChange", 1);
    this.wppActionClick = createEvent(this, "wppActionClick", 1);
    this.isSearchResultFound = true;
    this.isMatchSearch = (title, search) => {
      if (this.searchConfig?.isMatchSearch)
        return this.searchConfig.isMatchSearch(title, search);
      const titleTerm = title.toLowerCase().split(' ').filter(Boolean);
      const searchTerm = search.toLowerCase().split(' ').filter(Boolean);
      return titleTerm.some(substr => searchTerm.some(search => substr.includes(search)));
    };
    this.multipleSelectionUpdate = (tree, item) => {
      const { id, selected, children, indeterminate } = item;
      let updatedTree;
      if (children?.length && (selected || indeterminate)) {
        updatedTree = updateTreeById(tree, id, {
          children: markChildrenAs(children, ({ disabled }) => ({ ...(!disabled && { selected: true }) })),
        });
      }
      if (children?.length && !selected && !indeterminate) {
        updatedTree = updateTreeById(tree, id, {
          children: markChildrenAs(children, () => ({ selected: false })),
        });
      }
      const treeState = recalculateIndeterminateTreeState(updatedTree || tree);
      const selectedItems = findSelectedItems(treeState);
      this.wppChange.emit({
        treeState,
        currentItem: item,
        selectedItems: findSelectedItems(treeState),
        selectedOriginalItems: convertToOriginalItems(selectedItems),
        reason: 'select',
      });
    };
    this.singleSelectionUpdate = (tree, item) => {
      const { id, selected } = item;
      let treeWithUnselectedPreviousItem;
      const updatedTree = updateTreeById(tree, id, {
        selected,
      });
      if (selected) {
        treeWithUnselectedPreviousItem = updateTreeById(updatedTree, this.selectedIds[0], {
          selected: false,
        });
        this.selectedIds = [id];
      }
      else {
        this.selectedIds = [];
      }
      const treeState = treeWithUnselectedPreviousItem || updatedTree;
      const selectedItems = findSelectedItems(treeState);
      this.wppChange.emit({
        treeState,
        currentItem: item,
        selectedItems,
        selectedOriginalItems: convertToOriginalItems(selectedItems),
        reason: 'select',
      });
    };
    this.updateTreeWithSearch = (tree, search) => tree.map((item) => {
      const isMatch = this.isMatchSearch(item.title, search);
      if (!this.isSearchResultFound && isMatch)
        this.isSearchResultFound = true;
      if (item.children?.length) {
        // If found parent item has match, we don't need to recursive call this.updateTreeWithSearch function anymore.
        // Instead we should mark all of his children as visible( hidden: false)
        // and if some children items has match - mark their parents as open.
        if (isMatch) {
          const haveMatchedChildrenHost = isHaveFoundChildren(item.children, search, this.isMatchSearch);
          const children = markChildrenAs(item.children, item => {
            if (item.children?.length) {
              const haveMatchedChildren = isHaveFoundChildren(item.children, search, this.isMatchSearch);
              return { hidden: false, open: haveMatchedChildren };
            }
            return { hidden: false };
          });
          return { ...item, children, open: haveMatchedChildrenHost, hidden: false };
        }
        const haveMatchedChildren = isHaveFoundChildren(item.children, search, this.isMatchSearch);
        const children = this.updateTreeWithSearch(item.children, search);
        return {
          ...item,
          children,
          open: haveMatchedChildren,
          hidden: !haveMatchedChildren && !isMatch,
        };
      }
      else {
        return { ...item, hidden: !isMatch };
      }
    });
    this.checkData = (treeData) => {
      if (!this.multiple) {
        if (findSelectedItems(treeData).length > 1) {
          throw new Error('Several selected items found in provided data. There is could be only one selected item in single mode, otherwise, use multiple mode.');
        }
        if (this.defaultSelectedIds.length > 1) {
          throw new Error('Several items found in provided defaultSelectedIds prop. There is could be only one selected item in single mode, otherwise, use multiple mode. ');
        }
      }
      return treeData;
    };
    this.hostCssClasses = () => ({
      'wpp-tree': true,
    });
    this.renderIconsList = (item, icons, place = 'end') => (h("div", { slot: `icon-${place}`, key: uuidv4() }, h("wpp-menu-context-v2-13-3", { appendToListWrapper: true, dropdownConfig: {
        popperOptions: { strategy: 'fixed' },
        trigger: 'mouseenter',
        interactiveDebounce: 15,
        interactiveBorder: 25,
        offset: [0, 0],
      } }, h("wpp-icon-more-v2-13-3", { class: {
        'menu-trigger': true,
        disabled: !!item.disabled,
      }, style: { padding: '4px', color: 'var(--wpp-grey-color-800)' }, direction: "horizontal", slot: "trigger-element" }), h("div", null, icons.map(({ icon, name }) => (h("wpp-list-item-v2-13-3", { key: name, value: name, onClick: this.handleActionClick({ item, name, place }) }, h(transformToVersionedTag(icon), { slot: 'left' }), h("p", { slot: "label" }, name))))))));
    this.renderTree = (treeData, level = 1) => treeData.map(item => {
      if (item.children) {
        return (h("wpp-tree-item-v2-13-3", { text: item.title, item: item, level: level, multiple: this.multiple, search: this.search, highlightOptions: this.searchConfig.highlightOptions, transformSearchQuery: this.searchConfig.transformSearchQuery, disableSearchHighlight: this.disableSearchHighlight, disableOpenCloseAnimation: this.disableOpenCloseAnimation, withItemsTruncation: this.withItemsTruncation, treeWidth: Number(this.host.clientWidth) }, item.iconStart?.icon &&
          h(transformToVersionedTag(item.iconStart.icon), {
            slot: 'icon-start',
            part: 'icon-start',
            onclick: this.handleActionClick({ item, name: item.iconStart.name, place: 'start' }),
          }), item.iconsStart && this.renderIconsList(item, item.iconsStart, 'start'), item.iconsEnd && this.renderIconsList(item, item.iconsEnd), !item.iconsEnd &&
          item.iconEnd?.icon &&
          h(transformToVersionedTag(item.iconEnd.icon), {
            slot: 'icon-end',
            part: 'icon-end',
            onclick: this.handleActionClick({ item, name: item.iconEnd.name, place: 'end' }),
          }), h("div", { slot: "content", class: "content-container", part: "content" }, item.open && this.renderTree(item.children, level + 1))));
      }
      return (h("wpp-tree-item-v2-13-3", { text: item.title, item: item, level: level, multiple: this.multiple, search: this.search, highlightOptions: this.searchConfig.highlightOptions, transformSearchQuery: this.searchConfig.transformSearchQuery, disableSearchHighlight: this.disableSearchHighlight, disableOpenCloseAnimation: this.disableOpenCloseAnimation, withItemsTruncation: this.withItemsTruncation, treeWidth: Number(this.host.clientWidth) }, item.iconStart?.icon &&
        h(transformToVersionedTag(item.iconStart.icon), {
          slot: 'icon-start',
          part: 'icon-start',
          onclick: this.handleActionClick({ item, name: item.iconStart.name, place: 'start' }),
        }), item.iconsStart && this.renderIconsList(item, item.iconsStart, 'start'), item.iconsEnd && this.renderIconsList(item, item.iconsEnd), !item.iconsEnd &&
        item.iconEnd?.icon &&
        h(transformToVersionedTag(item.iconEnd.icon), {
          slot: 'icon-end',
          part: 'icon-end',
          onclick: this.handleActionClick({ item, name: item.iconEnd.name, place: 'end' }),
        })));
    });
    this.currentTreeData = undefined;
    this.selectedIds = [];
    this.data = undefined;
    this.search = '';
    this.multiple = false;
    this.defaultSelectedIds = [];
    this.locales = {
      nothingFound: 'No result',
    };
    this.searchConfig = {
      isMatchSearch: undefined,
      highlightOptions: {},
      transformSearchQuery: undefined,
    };
    this.disableSearchHighlight = false;
    this.disableOpenCloseAnimation = false;
    this.withItemsTruncation = false;
  }
  onInputChange(searchText) {
    if (!searchText.trim()) {
      const treeState = this.currentTreeData.map(item => ({
        ...item,
        hidden: false,
        open: false,
        ...(item.children?.length && {
          children: markChildrenAs(item.children, item => ({
            hidden: false,
            ...(item.children?.length && { open: false }),
          })),
        }),
      }));
      this.isSearchResultFound = true;
      const selectedItems = findSelectedItems(treeState);
      this.wppChange.emit({
        treeState,
        selectedItems,
        selectedOriginalItems: convertToOriginalItems(selectedItems),
        reason: 'search',
      });
      return;
    }
    this.isSearchResultFound = false;
    const treeState = this.updateTreeWithSearch(this.currentTreeData, searchText);
    const selectedItems = findSelectedItems(treeState);
    this.wppChange.emit({
      treeState,
      selectedItems,
      selectedOriginalItems: convertToOriginalItems(selectedItems),
      reason: 'search',
    });
  }
  updateDate(newData) {
    this.currentTreeData = newData;
  }
  handleOpenItem(event) {
    event.stopPropagation();
    const item = event.detail;
    const treeState = updateTreeById(this.currentTreeData, item.id, item);
    const selectedItems = findSelectedItems(treeState);
    this.wppChange.emit({
      treeState,
      currentItem: item,
      selectedItems,
      selectedOriginalItems: convertToOriginalItems(selectedItems),
      reason: 'open',
    });
  }
  handleSelectedItem(event) {
    event.stopPropagation();
    const newItemState = event.detail;
    const updatedTreeWithCurrentItem = updateTreeById(this.currentTreeData, newItemState.id, newItemState);
    if (this.multiple) {
      this.multipleSelectionUpdate(updatedTreeWithCurrentItem, newItemState);
    }
    else {
      this.singleSelectionUpdate(updatedTreeWithCurrentItem, newItemState);
    }
  }
  componentDidLoad() {
    // NOTE: defaultSelectedIds should be provided only when default selection logic is applied. Recalculating tree state
    // here may break your custom selection logic
    if (this.defaultSelectedIds.length > 0) {
      this.currentTreeData = recalculateIndeterminateTreeState(updateTreeByIds(this.currentTreeData, this.defaultSelectedIds, ({ isNotSelectable, disabled }) => ({
        ...(!isNotSelectable && !disabled && { selected: true }),
      })));
    }
    if (this.disableOpenCloseAnimation) {
      this.host.style.setProperty('--wpp-tree-item-switcher-transition-duration', '50ms');
    }
  }
  handleActionClick({ item, name, place, }) {
    return (event) => {
      event.stopPropagation();
      if (!item.loadingActions) {
        this.wppActionClick.emit({
          id: item.id,
          item,
          name,
          place,
        });
      }
    };
  }
  componentWillLoad() {
    this.currentTreeData = this.checkData(this.data);
  }
  render() {
    return (h(Host, { class: this.hostCssClasses(), exportparts: "tree-container, tree-empty-text" }, h("div", { class: "container", part: "tree-container" }, this.currentTreeData && this.isSearchResultFound ? (this.renderTree(this.currentTreeData)) : (h("p", { class: "empty-tree-text", part: "tree-empty-text" }, this.locales.nothingFound)))));
  }
  static get registryIs() { return "wpp-tree-v2-13-3"; }
  get host() { return this; }
  static get watchers() { return {
    "search": ["onInputChange"],
    "data": ["updateDate"]
  }; }
  static get style() { return wppTreeCss; }
}, [1, "wpp-tree", "wpp-tree-v2-13-3", {
    "data": [16],
    "search": [1],
    "multiple": [516],
    "defaultSelectedIds": [16],
    "locales": [16],
    "searchConfig": [16],
    "disableSearchHighlight": [4, "disable-search-highlight"],
    "disableOpenCloseAnimation": [4, "disable-open-close-animation"],
    "withItemsTruncation": [4, "with-items-truncation"],
    "currentTreeData": [32],
    "selectedIds": [32]
  }, [[2, "wppTreeItemOpenChange", "handleOpenItem"], [2, "wppTreeItemSelectChange", "handleSelectedItem"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-tree-v2-13-3", "wpp-action-button-v2-13-3", "wpp-checkbox-v2-13-3", "wpp-icon-chevron-v2-13-3", "wpp-icon-cross-v2-13-3", "wpp-icon-dash-v2-13-3", "wpp-icon-error-v2-13-3", "wpp-icon-info-v2-13-3", "wpp-icon-more-v2-13-3", "wpp-icon-success-v2-13-3", "wpp-icon-tick-v2-13-3", "wpp-icon-triangle-fill-v2-13-3", "wpp-icon-warning-v2-13-3", "wpp-inline-message-v2-13-3", "wpp-internal-label-v2-13-3", "wpp-internal-tooltip-v2-13-3", "wpp-label-v2-13-3", "wpp-list-item-v2-13-3", "wpp-menu-context-v2-13-3", "wpp-spinner-v2-13-3", "wpp-tooltip-v2-13-3", "wpp-tree-item-v2-13-3", "wpp-typography-v2-13-3"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-tree-v2-13-3":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppTree$1);
      }
      break;
    case "wpp-action-button-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$n();
      }
      break;
    case "wpp-checkbox-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$m();
      }
      break;
    case "wpp-icon-chevron-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$l();
      }
      break;
    case "wpp-icon-cross-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$k();
      }
      break;
    case "wpp-icon-dash-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$j();
      }
      break;
    case "wpp-icon-error-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$i();
      }
      break;
    case "wpp-icon-info-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$h();
      }
      break;
    case "wpp-icon-more-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$g();
      }
      break;
    case "wpp-icon-success-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$f();
      }
      break;
    case "wpp-icon-tick-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$e();
      }
      break;
    case "wpp-icon-triangle-fill-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$d();
      }
      break;
    case "wpp-icon-warning-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$c();
      }
      break;
    case "wpp-inline-message-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$b();
      }
      break;
    case "wpp-internal-label-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$a();
      }
      break;
    case "wpp-internal-tooltip-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$9();
      }
      break;
    case "wpp-label-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$8();
      }
      break;
    case "wpp-list-item-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "wpp-menu-context-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "wpp-spinner-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "wpp-tooltip-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "wpp-tree-item-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "wpp-typography-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}
defineCustomElement$1();

const WppTree = WppTree$1;
const defineCustomElement = defineCustomElement$1;

export { WppTree, defineCustomElement };
